import React from 'react'
import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import Select from "react-select";

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './Stock.css'
import { useTranslation } from "react-i18next";

const Stock = () => {
  const { t } = useTranslation();

  const {shop} = useParams();

  const [packageList, setPackageList] = useState([]);

  const options = [
    {value: 1, label: t('stock.preparation')},
    {value: 2, label: t('stock.sale')},
    {value: 6, label: t('stock.release')},
    {value: 3, label: t('stock.soldout')},
    {value: 4, label: t('stock.ended')},
    {value: 7, label: t('stock.stopping')}
  ];

  const [status, setStatus] = useState(options);
  const [packageName, setPackageName] = useState('');
  const [packageType, setPackageType] = useState(0);
  const [packageTypeList, setPackageTypeList] = useState({});

  const [loading, setLoading] = useState("読み込み中...");

  useEffect(() => {
    let params = new URLSearchParams();
    status.forEach((s, i) => {
      params.append('status[' + i + ']', s.value)
    })
    params.append('name', packageName);
    params.append('type', packageType);

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    const api = () => {
      fetch(`${process.env.REACT_APP_API_URL}/api/package?${params.toString()}`, {
        headers: {
          'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
          'Bearer': decodeURIComponent(token),
          'Accept': 'application/json'
        },
        credentials: 'include',
      })
      .then(response => response.json())
      .then(data => {
        if(!data.errors) {
          if (!data.packages) {
            return;
          }
          setPackageList(data.packages.map((package_info) => {
            return {
              "id": package_info.id,
              "url": process.env.REACT_APP_ASSET_URL + package_info.image_url,
              "name": package_info.name,
              "number": package_info.number,
              "stock": package_info.stock,
              "price": package_info.price,
              "start": package_info.start_at.split(' ')[0],
              "end": package_info.end_at.split(' ')[0],
              "status": package_info.status
            }
          }))
          setLoading(t('stock.error'));
        }
      })
    }

    const timer = setTimeout(() => {
      api();
    }, 500)

  }, [status, packageName, packageType]);

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/package-master`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': xsrfToken,
        'Authorization': `Bearer ${token}`
      },
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      setPackageTypeList(data.package_type_masters);
    })
    .catch(err => {
      console.log(err);
    });
  }, []);

  const CreatePackageTypeSelectList = () => {
    if (!packageTypeList.length) return;

    let list = [];
    list.push(<option key={"all"} value={0}>{t('stock.all')}</option>);

    list = list.concat(packageTypeList.map((p, index) => {
      return (
        <option key={"master"+index} value={p.id}>{t('package_master.' + p.package_type_name)}</option>
      )
    }))

    return list;
  };

  const CreatePackageList = () => {
    if (!packageList.length) {
      return (
        <tr>
          <td colSpan="7">{loading}</td>
        </tr>
      )
    }
    return packageList.map((package_info) => {
      return (
        <Tr stock={package_info} key={"stock"+package_info.id} />
      )
    })
  }
  

  return (
    <>
      <Header />
      <SideMenu />
      <div className="stock">
        <div className="stock-title">{t('stock.title')}</div>
        <div className="stock-create">
          <Link to={`/${shop}/new-oripa`}>
            <button className="stock-create-button">{t('stock.new')}</button>
          </Link>
        </div>
        <div className='clearfix'></div>
        <div className="stock-search">
          <table className="stock-search-table">
            <tbody>
              <tr>
                <th>
                  <label className="stock-search-label">{t('stock.status')}</label>
                </th>
              </tr>
              <tr>
                <td>
                  <Select
                    className="stock-search-select"
                    classNamePrefix="stock-search-select"
                    options={options}
                    defaultValue={status}
                    onChange={(e) => setStatus(e)}
                    isMulti
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table className="stock-search-table">
            <tbody>
              <tr>
                <th>
                  <label className="stock-search-label">{t('stock.kind')}</label>
                </th>
                <th>
                  <label className="stock-search-label">{t('stock.name')}</label>
                </th>
              </tr>
              <tr>
                <td>
                  <select className="stock-search-select" onChange={(e) => setPackageType(e.target.value)} value={packageType}>
                    <CreatePackageTypeSelectList />
                  </select>
                </td>
                <td>
                  <input className="stock-search-input" type="text" onChange={(e) => setPackageName(e.target.value)} value={packageName} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="stock-content">
          <div className="stock-content-table">
            <table className="stock-content-table">
              <thead>
                <tr>
                  <th>{t('stock.pop')}</th>
                  <th>{t('stock.name')}</th>
                  <th>{t('stock.cards')}</th>
                  <th>{t('stock.price')}</th>
                  <th>{t('stock.period')}</th>
                  <th>{t('stock.status')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <CreatePackageList />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default Stock